import { render, staticRenderFns } from "./WorkIconNavSystemConfiguration.vue?vue&type=template&id=6c58e700"
import script from "./WorkIconNavSystemConfiguration.vue?vue&type=script&lang=js"
export * from "./WorkIconNavSystemConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports